export const LEVEL_TYPE = {
  WHITE: 1,
  YELLOW: 2,
  ORANGE: 3,
  GREEN: 4,
  BLUE: 5,
  PURPLE: 6,
  BROWN: 7,
  RED_1: 8,
  RED_2: 9,
  BLACK_1: 101,
  BLACK_2: 102,
  BLACK_3: 103,
  BLACK_4: 104,
  BLACK_5: 105,
  BLACK_6: 106,
  BLACK_7: 107,
  BLACK_8: 108,
  BLACK_9: 109,
} as const;

export type Level = (typeof LEVEL_TYPE)[keyof typeof LEVEL_TYPE];

interface Props {
  level: Level;
}

const BELT_COLORS: Record<Level, string> = {
  [LEVEL_TYPE.RED_2]: "#FF0000",
  [LEVEL_TYPE.RED_1]: "#FF0000",
  [LEVEL_TYPE.BROWN]: "#964B00",
  [LEVEL_TYPE.GREEN]: "#169415",
  [LEVEL_TYPE.BLUE]: "#002BFF",
  [LEVEL_TYPE.PURPLE]: "#AD00FF",
  [LEVEL_TYPE.ORANGE]: "#FFA500",
  [LEVEL_TYPE.YELLOW]: "#FFFF00",
  [LEVEL_TYPE.WHITE]: "#FFFFFF",
  [LEVEL_TYPE.BLACK_1]: "#000000",
  [LEVEL_TYPE.BLACK_2]: "#000000",
  [LEVEL_TYPE.BLACK_3]: "#000000",
  [LEVEL_TYPE.BLACK_4]: "#000000",
  [LEVEL_TYPE.BLACK_5]: "#000000",
  [LEVEL_TYPE.BLACK_6]: "#000000",
  [LEVEL_TYPE.BLACK_7]: "#000000",
  [LEVEL_TYPE.BLACK_8]: "#000000",
  [LEVEL_TYPE.BLACK_9]: "#000000",
};

export const LEVEL_TEXT: Record<Level, string> = {
  1: "9th kup",
  2: "8th kup",
  3: "7th kup",
  4: "6th kup",
  5: "5th kup",
  6: "4th kup",
  7: "3rd kup",
  8: "2nd kup",
  9: "1st kup",
  101: "1st dan",
  102: "2nd dan",
  103: "3rd dan",
  104: "4th dan",
  105: "5th dan",
  106: "6th dan",
  107: "7th dan",
  108: "8th dan",
  109: "9th dan",
};

export const Belt = ({ level }: Props) => {
  if (!level) return null;
  return (
    <div
      className={"w-[60px] border h-[18px]"}
      style={{
        background: BELT_COLORS[level],
      }}
    />
  );
};
